import React, { Component } from 'react';
import { Container, Row, Col, Card, Button } from 'reactstrap';
import { HeroSection } from './sections/HeroSection';
import { AboutSection } from './sections/AboutSection';
import { EventsSection } from './sections/EventsSection';
import { NewsCarousel } from './sections/NewsCarousel';
import { ScheduleSection } from './sections/ScheduleSection';
import { GallerySection } from './sections/GallerySection';
import { ContactSection } from './sections/ContactSection';
import { SocialSection } from './sections/SocialSection';
import { WhatsAppButton } from './shared/WhatsAppButton';
import { Footer } from './shared/Footer';

export class Home extends Component {
  static displayName = Home.name;

  render() {
    return (
      <div>
        <HeroSection />
        <AboutSection />
        <NewsCarousel />
        <EventsSection />
        <ScheduleSection />
        <GallerySection />
        <SocialSection />
        <ContactSection />
        <Footer />
        <WhatsAppButton />
      </div>
    );
  }
}
